var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getPostWithoutOriginals = function (post) {
    var _a;
    var newAttachments = (_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a.map(function (attachment) { var _a; return (__assign(__assign({}, attachment), { files: (_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.filter(function (file) { return (file === null || file === void 0 ? void 0 : file.size) !== 'original'; }) })); });
    return __assign(__assign({}, post), { attachments: newAttachments });
};
//# sourceMappingURL=getPostWithoutOriginals.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getPostWithoutOriginals = function (post) {
    var _a;
    var newAttachments = (_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a.map(function (attachment) { var _a; return (__assign(__assign({}, attachment), { files: (_a = attachment === null || attachment === void 0 ? void 0 : attachment.files) === null || _a === void 0 ? void 0 : _a.filter(function (file) { return (file === null || file === void 0 ? void 0 : file.size) !== 'original'; }) })); });
    return __assign(__assign({}, post), { attachments: newAttachments });
};
//# sourceMappingURL=getPostWithoutOriginals.js.map